import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon, ShieldAlertIcon, ListOrderedIcon, CheckCircleIcon, ClipboardIcon, AwardIcon, TargetIcon, PrinterIcon } from 'lucide-react';
export function ClassDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const displayName = slug?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || 'Class';
  return <div className="space-y-8 max-w-3xl" data-id="element-1902">
      <Link to="/student/my-classes" className="inline-flex items-center gap-1.5 text-sm text-purple-700 hover:text-purple-900 transition-colors" data-id="element-1903">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-1904" />
        Back to My Classes
      </Link>

      {/* Course Header Banner */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1905">
        <div className="flex items-center gap-2 mb-1" data-id="element-1906">
          <BookOpenIcon className="h-5 w-5 text-yellow-300" data-id="element-1907" />
          <span className="text-purple-200 text-xs font-semibold uppercase tracking-wider" data-id="element-1908">
            On-Demand Class
          </span>
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight" data-id="element-1909">
          {displayName}
        </h1>
      </div>

      {/* Course Description Card */}
      <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-1910">
        <div className="px-4 py-3 flex items-center gap-2" style={{
        backgroundColor: '#4A2D8F'
      }} data-id="element-1911">
          <BookOpenIcon className="h-4 w-4 text-yellow-300 flex-shrink-0" data-id="element-1912" />
          <p className="text-white text-xs font-bold" data-id="element-1913">About This Course</p>
        </div>
        <div className="bg-white px-5 py-4" data-id="element-1914">
          <p className="text-sm text-slate-700 leading-relaxed" data-id="element-1915">
            This class will review the way real estate agency representation is
            provided in Arizona, how licensees are obligated to disclose their
            agency to the clients, and the various means of representing
            clients. Dual agency, exclusive agency, implied agency and
            facilitation will be reviewed.
          </p>
        </div>
      </div>

      {/* Identity Verification Warning */}
      <div className="flex items-start gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-5 py-4" data-id="element-1916">
        <ShieldAlertIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1917" />
        <div data-id="element-1918">
          <p className="text-sm font-extrabold text-amber-800 uppercase tracking-wide mb-1" data-id="element-1919">
            Identity Verification Required
          </p>
          <p className="text-sm text-amber-900 leading-relaxed" data-id="element-1920">
            The Arizona Department of Real Estate requires that we confirm your
            identity and that you are the person taking the classes.
            Impersonating a real estate licensee is a felony in the State of
            Arizona and will be subject to a real estate forfeiture for either
            or both parties. If you are NOT the person named in the
            registration, we strongly recommend that you log out and not
            continue. We reserve the right to use reasonable means to verify
            your identity.
          </p>
        </div>
      </div>

      {/* Course Requirements */}
      <div data-id="element-1921">
        <div className="flex items-center gap-2 mb-4" data-id="element-1922">
          <ListOrderedIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-1923" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-1924">
            Course Details
          </h2>
        </div>

        <div className="space-y-3" data-id="element-1925">
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1926">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1927">
              <ClipboardIcon className="h-4 w-4" data-id="element-1928" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1929">
              <span className="font-bold text-slate-900" data-id="element-1930">5 sections</span> to
              complete in this course
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1931">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1932">
              <BookOpenIcon className="h-4 w-4" data-id="element-1933" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1934">
              <span className="font-bold text-slate-900" data-id="element-1935">Take NOTES:</span> You
              can print pages or copy & paste for your notes
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1936">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1937">
              <CheckCircleIcon className="h-4 w-4" data-id="element-1938" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1939">
              <span className="font-bold text-slate-900" data-id="element-1940">Review anytime.</span>{' '}
              You can review the material at any time throughout the course
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1941">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-1942">
              <TargetIcon className="h-4 w-4" data-id="element-1943" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1944">
              <span className="font-bold text-slate-900" data-id="element-1945">
                100% to pass each quiz
              </span>{' '}
              in order to proceed to the next section
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1946">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-1947">
              <AwardIcon className="h-4 w-4" data-id="element-1948" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1949">
              <span className="font-bold text-slate-900" data-id="element-1950">
                80% to pass the final.
              </span>{' '}
              The final is a compilation of the quiz questions you have already
              answered
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1951">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#2E7D32'
          }} data-id="element-1952">
              <PrinterIcon className="h-4 w-4" data-id="element-1953" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1954">
              <span className="font-bold text-slate-900" data-id="element-1955">
                Certificate date stamped
              </span>{' '}
              upon completion of your final. If you'd like to remain paperless,
              click "Print Certificate" to download a PDF. Save in a folder for{' '}
              <strong className="text-base" data-id="element-1956">5</strong> years (per ADRE rules)
            </div>
          </div>
        </div>
      </div>

      {/* Your Class Button */}
      <div className="flex justify-center pt-2" data-id="element-1957">
        <Link to={`/student/class/${slug}/content`} className="inline-block px-14 py-3.5 text-white text-lg font-extrabold rounded-lg transition-all hover:scale-[1.02] shadow-md text-center" style={{
        backgroundColor: '#CC0000'
      }} data-id="element-1958">
          Your Class
        </Link>
      </div>
    </div>;
}